"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeHandler = void 0;
const message_1 = require("../message");
const base_handler_1 = require("./base_handler");
const client_handler_1 = require("./client_handler");
const publisher_handler_1 = require("./publisher_handler");
const service_handler_1 = require("./service_handler");
const subscription_handler_1 = require("./subscription_handler");
class NodeHandler extends base_handler_1.BaseHandler {
    constructor(connection, id) {
        super(connection, id);
    }
    async destroy() {
        await this.sendRequest(message_1.MessageType.DESTROY_NODE, {
            node_id: this.id,
        });
        this.cleanUp();
    }
    async createPublisher(messageType, topicName) {
        const response = await this.sendRequest(message_1.MessageType.CREATE_PUBLISHER, {
            node_id: this.id,
            message_type: messageType,
            topic_name: topicName,
        });
        const publisher = new publisher_handler_1.PublisherHandler(this.connection, response.content["publisher_id"]);
        this.attach(publisher);
        return publisher;
    }
    async createSubscription(messageType, topicName, callback) {
        const response = await this.sendRequest(message_1.MessageType.CREATE_SUBSCRIPTION, {
            node_id: this.id,
            message_type: messageType,
            topic_name: topicName,
        });
        const subscription = new subscription_handler_1.SubscriptionHandler(this.connection, response.content["subscription_id"], callback);
        this.attach(subscription);
        return subscription;
    }
    async createClient(serviceType, serviceName) {
        const response = await this.sendRequest(message_1.MessageType.CREATE_CLIENT, {
            node_id: this.id,
            service_type: serviceType,
            service_name: serviceName,
        });
        const client = new client_handler_1.ClientHandler(this.connection, response.content["client_id"]);
        this.attach(client);
        return client;
    }
    async createService(serviceType, serviceName, callback) {
        const response = await this.sendRequest(message_1.MessageType.CREATE_SERVICE, {
            node_id: this.id,
            service_type: serviceType,
            service_name: serviceName,
        });
        const service = new service_handler_1.ServiceHandler(this.connection, response.content["service_id"], callback);
        this.attach(service);
        return service;
    }
}
exports.NodeHandler = NodeHandler;
